import {
  FeedbackModalActions,
  FeedbackModalIcon,
} from '#/components/FeedbackModal/FeedbackModal.styled';
import { Form } from '#/components/Form/Form';
import {
  type FormContextValue,
  type FormSubmitFunction,
} from '#/components/Form/FormContext';
import { SubmitButton } from '#/components/Form/SubmitButton/SubmitButton';
import { TextAreaField } from '#/components/Form/TextAreaField';
import { useI18n } from '#/i18n/hooks/useI18n';
import { Modal } from '#/modals/Modal';
import { getStaticImageSrc } from '#/utils/getImageSrc';

type FeedbackModalProps = {
  isPositive: boolean;
  onSubmit: (comment: string) => Promise<void>;
  onClose: (hasSubmittedFeedback: boolean) => void;
  titlePositive: string;
  titleNegative: string;
  analyticsTitle: string;
  qaId: string;
};

type FeedbackFormValues = {
  comment: string;
};

export function FeedbackModal({
  isPositive,
  onSubmit,
  onClose,
  titlePositive,
  titleNegative,
  analyticsTitle,
  qaId,
}: FeedbackModalProps) {
  const { i18n } = useI18n();

  const handleSubmit: FormSubmitFunction<FeedbackFormValues> = async ({
    values,
  }) => {
    await onSubmit(values.comment);
    onClose(true);
  };

  return (
    <Modal
      title={isPositive ? titlePositive : titleNegative}
      onClose={() => onClose(false)}
      qaId={qaId}
      image={
        <FeedbackModalIcon
          src={getStaticImageSrc('feedback-modal-icon-lightbulb.svg')}
          alt=""
        />
      }
    >
      <Form<FeedbackFormValues, FormContextValue<FeedbackFormValues>>
        analyticsTitle={analyticsTitle}
        usageContext="modal"
        qaId={`${qaId}-form`}
        onSubmit={handleSubmit}
        render={() => (
          <>
            <TextAreaField
              name="comment"
              rows={6}
              placeholder={i18n('Enter text here…')}
            />
            <FeedbackModalActions>
              <SubmitButton>Submit</SubmitButton>
            </FeedbackModalActions>
          </>
        )}
      />
    </Modal>
  );
}
